import { sentryCapture } from '../errorHandlers';
import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import isEmpty from 'lodash.isempty';

export default function useFetchRest(endpoint, options = {}) {
    let query = {
        queryKey: [endpoint],
        queryFn: () =>
            axios
                .get(`/wp-json/range_headless/v1/${endpoint}`)
                .then((res) => res.data),
        throwOnError: (err) => {
            err.level = 'fatal';
            sentryCapture(err);
            return true;
        },
        staleTime: Infinity,
    };

    if (!isEmpty(options)) {
        query = { ...query, ...options };
    }

    return useQuery(query);
}
